import React, { useState } from "react";

export default function WeatherTemperature(props) {
  const [unit, setUnit] = useState("celcius");

  function showFahrenheit(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }

  function showCelcius(event) {
    event.preventDefault();
    setUnit("celcius");
  }

  function fahrenheitTemperature() {
    return (props.celcius * 9) / 5 + 32;
  }

  if (unit === "celcius") {
    return (
      <div className="WeatherTemperature">
        <div className="overviewTemp">
          {/* <img src={weather.icon} alt={weather.description} /> */}
          <img src={props.iconSource} alt="weather-icon"></img>
          <h1 id="theTemperature">{Math.round(props.celcius)}</h1>
          <span className="units">
            °C |{" "}
            <a href="/" onClick={showFahrenheit}>
              °F
            </a>
          </span>
        </div>
      </div>
    );
  } else {
    return (
      <div className="WeatherTemperature">
        <div className="overviewTemp">
          {/* <img src={weather.icon} alt={weather.description} /> */}
          <img src={props.iconSource} alt="weather-icon"></img>
          <h1 id="theTemperature">{Math.round(fahrenheitTemperature())}</h1>
          <span className="units">
            <a href="/" onClick={showCelcius}>
              °C
            </a>{" "}
            | °F
          </span>
        </div>
      </div>
    );
  }
}
